<template>
  <div class="dialog-root">
    <div class="container">
      <el-form ref="formRef" :model="formData" label-width="130px">
        <el-row>
          <el-col span="12">
            <el-form-item
              prop="serviceNo"
              label="话务号："
              :rules="[{ required: true, message: '请输入话务号', trigger: 'blur' }]"
            >
              <el-input
                v-model="formData.serviceNo"
                placeholder="请输入 话务号"
                maxlength="20"
                show-word-limit
                clearable
                :disabled="dialogType == 'add' ? false : true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12"> </el-col>
          <el-col span="12">
            <el-form-item
              prop="userId"
              label="坐席名称："
              :rules="[{ required: true, message: '请选择坐席名称', trigger: 'blur' }]"
            >
              <choicePeople
                :single="true"
                :allUserList="operatorList"
                :remainUserListInside.sync="operatorList"
                :projectId="projectId"
                placeholder="请选择 坐席名称"
                message="请选择坐席"
              ></choicePeople>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="坐席工号：">
              <el-input v-model="userCode" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="主服务类别："
              prop="serviceItemMain"
              :rules="[{ required: true, message: '请选择主服务类别' }]"
            >
              <el-select
                style="width: 100%"
                v-model="formData.serviceItemMain"
                placeholder="请选择 主服务类别"
              >
                <el-option
                  v-for="(item, index) in serviceTypes"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="次服务类别："
              prop="serviceItemSecondary"
              :rules="[{ required: true, message: '请选择次服务类别' }]"
            >
              <el-select
                style="width: 100%"
                v-model="formData.serviceItemSecondary"
                placeholder="请选择 次服务类别"
              >
                <el-option
                  v-for="(item, index) in serviceTypes"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="岗位类别："
              prop="serviceRole"
              :rules="[{ required: true, message: '请选择岗位类别' }]"
            >
              <el-select
                style="width: 100%"
                v-model="formData.serviceRole"
                placeholder="请选择 岗位类别"
              >
                <el-option
                  v-for="(item, index) in roles"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="externalPhone"
              label="外线电话："
              :rules="[
                { required: true, message: '请输入外线电话', trigger: 'blur' },
                {
                  pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
                  message: '请输入正确的手机号',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="formData.externalPhone"
                placeholder="请输入 外线电话"
                maxlength="20"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">
        {{ dialogType == 'add' ? '保存' : '修改' }}
      </el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import choicePeople from '@/components/user-edit-box/user-edit-box2';
import { getDictApi, getUserInfoApi } from '@/api/call-system/index';
import { addApi, bindApi } from '@/api/call-system/call-manage/operator-manage';

export default {
  props: ['dialogType', 'projectId', 'rowData'],
  components: { choicePeople },
  data() {
    return {
      formData: {}, // 表单数据
      userCode: '', // 坐席工号
      serviceTypes: [], // 服务类别字典
      roles: [], // 坐席角色字典
      operatorList: [], // 已选坐席人员的合集
    };
  },
  watch: {
    operatorList(val) {
      if (val && val.length > 0) {
        this.formData.userId = this.operatorList[0].id;
      } else {
        this.formData.userId = '';
      }
      // 根据坐席人员拿到坐席工号
      this.userCode = '';
      if (this.formData.userId) {
        getUserInfoApi({
          id: this.formData.userId,
        }).then(({ data }) => {
          this.userCode = data.code;
        });
      }
    },
  },
  created() {
    if (this.dialogType == 'bind') {
      // 选人组件要求传递的参数除了id还有realName或realNameAndPhone
      this.operatorList = [
        {
          id: this.rowData.userId,
          realName: this.rowData.serverName,
        },
      ];
      this.formData = {
        id: this.rowData.id,
        userId: this.rowData.userId,
        serviceNo: this.rowData.serviceNo,
        serviceItemMain: this.rowData.serviceItemMain + '',
        serviceItemSecondary: this.rowData.serviceItemSecondary + '',
        serviceRole: this.rowData.serviceRole + '',
        externalPhone: this.rowData.externalPhone,
      };
    } else {
      this.formData.projectId = this.projectId;
    }
    getDictApi({
      code: 'callcenter_service_item',
    }).then(({ data }) => {
      this.serviceTypes = data;
    });
    getDictApi({
      code: 'callcenter_service_role',
    }).then(({ data }) => {
      this.roles = data;
    });
  },
  methods: {
    /* 保存 */
    doSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let fn = this.dialogType == 'add' ? addApi : bindApi;
          fn(this.formData, {
            showLoading: { text: '处理中...' },
          }).then(() => {
            this.$message.success('操作成功!');
            this.$emit('update');
          });
        }
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}

/* 选人组件的高度超限导致布局异常，所以需要统一高度 */
::v-deep .el-col-12 {
  height: 54px !important;
}
</style>
